import { useState, useEffect } from 'react';
import { Form, Button, Container } from 'react-bootstrap';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import { useGetAlauneQuery, useUpdateAlauneMutation } from '../../slices/alauneApiSlice';
import Message from '../../components/Message';
import { useGetBookListQuery } from '../../slices/booksApiSlice';
import { useGetAllNewsQuery } from '../../slices/newsApiSlice';
import { useGetAllAuthorsQuery } from '../../slices/authorsApiSlice';
import { useGetBooksCollectionsQuery } from '../../slices/booksCollectionsApiSlice';
import { useGetSubscribersQuery, useToggleSubscriberRegisteredMutation } from '../../slices/subscribersApiSlice';



const AdminHome = () => {
  const { data: alaune, isLoading, error } = useGetAlauneQuery();

  const [updateAlaune, { isLoading: loadingUpdate }] = useUpdateAlauneMutation();
  const [highlites, setHighlites] = useState([]);
  const [searchBookTerm, setSearchBookTerm] = useState('');
  const [searchNewsTerm, setSearchNewsTerm] = useState('');
  const [searchAuthorTerm, setSearchAuthorTerm] = useState('');
  const [searchBooksCollectionTerm, setSearchBooksCollectionTerm] = useState('');


  const { data: books, isLoading: loadingBooks } = useGetBookListQuery({
    keyword: searchBookTerm,
    adminSpace: 'true',
  });
  const bookList = books?.books || [];  

  const { data: news, isLoading: loadingNews } = useGetAllNewsQuery({
    keyword: searchNewsTerm,
    adminSpace: 'true',
  });
  const newsList = news?.news || []; 

  const { data: authors, isLoading: loadingAuthors } = useGetAllAuthorsQuery({
    keyword: searchAuthorTerm,
    adminSpace: 'true',
  });
  const authorsList = authors?.authors || []; 

  const { data: booksCollections, isLoading: loadingBooksCollections } = useGetBooksCollectionsQuery({
    keyword: searchBooksCollectionTerm,
    adminSpace: 'true',
  });
  console.log ('data : booksCollections : ', booksCollections)
  const booksCollectionsList = booksCollections?.booksCollections || [];
  console.log ('booksCollectionsList : ', booksCollectionsList)




  useEffect(() => {
    if (alaune?.highlites) {
      setHighlites(alaune.highlites);
    }
  }, [alaune]);

  const handleChange = (index, field, value) => {
    const updatedHighlites = [...highlites];
    updatedHighlites[index] = { ...updatedHighlites[index], [field]: value };

    // Si on change le typeInfo, on reset les ID liés
    if (field === 'typeInfo') {
      updatedHighlites[index].newsId = null;
      updatedHighlites[index].bookId = null;
      updatedHighlites[index].booksCollectionId = null;
      updatedHighlites[index].authorId = null;
    }

    setHighlites(updatedHighlites);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const payload = highlites.map((item) => {
        const newItem = { typeInfo: item.typeInfo };
  
        if (item.typeInfo !== 'newBook') {
          if (item.typeInfo === 'oldBook') {
            newItem.infoId = item.bookId || null;
          } else {
            newItem.infoId = item.newsId || item.booksCollectionId || item.authorId || null;
          }
        }
        return newItem;
      });
  
      await updateAlaune({ highlites: payload }).unwrap();
  
      toast.success('Bloc À La Une mis à jour');
    } catch (err) {
      console.log('err : ', err);
      toast.error(err?.data?.message || err.error);
    }
  };

  const getValueByTypeInfo = (highlite) => {
    if (highlite.typeInfo === 'news') return highlite.newsId || '';
    if (highlite.typeInfo === 'booksCollection') return highlite.booksCollectionId || '';
    if (highlite.typeInfo === 'author') return highlite.authorId || '';
    return '';
  };

  const handleIdChange = (index, value) => {
    const updatedHighlites = [...highlites];
    updatedHighlites[index] = {
      ...updatedHighlites[index],
      newsId: null,
      bookId: null,
      booksCollectionId: null,
      authorId: null,
    };

    const typeInfo = updatedHighlites[index].typeInfo;

    if (typeInfo === 'news') {
      updatedHighlites[index].newsId = value;
    } else if (typeInfo === 'oldBook') {
      updatedHighlites[index].bookId = value;
    } else if (typeInfo === 'booksCollection') {
      updatedHighlites[index].booksCollectionId = value;
    } else if (typeInfo === 'author') {
      updatedHighlites[index].authorId = value;
    }

    setHighlites(updatedHighlites);
  };

const { data: subscriberData, isLoading: loadingSubscribers } = useGetSubscribersQuery();
const [toggleSubscriberRegistered] = useToggleSubscriberRegisteredMutation();

const newSubscribers = subscriberData?.subscribers?.filter(s => !s.isRegistred) || [];


  return (
    <Container>
      <FormContainer>
        <div className="h1-adminContainer mt-4">
          <h1>Nouveaux abonnés à la newsletter</h1>
        </div>

        {loadingSubscribers ? (
          <Loader />
        ) : newSubscribers.length === 0 ? (
          <Message variant="info">Aucun nouvel abonné non enregistré.</Message>
        ) : (
          <div className="mb-4">
            {newSubscribers.map((subscriber) => (
              <div
                key={subscriber._id}
                className="d-flex justify-content-between align-items-center p-2 border rounded mb-2"
              >
                <span>{subscriber.email}</span>
                <Button
                  variant="outline-success"
                  size="sm"
                  onClick={async () => {
                    try {
                      await toggleSubscriberRegistered(subscriber._id).unwrap();
                      toast.success(`Abonné ${subscriber.email} marqué comme enregistré`);
                    } catch (err) {
                      toast.error("Erreur lors du changement de statut");
                    }
                  }}
                >
                  Marquer comme enregistré
                </Button>
              </div>
            ))}
          </div>
        )}
      </FormContainer>



      <FormContainer>
        <div className="h1-adminContainer">
          <h1>Gérer la Une</h1>
        </div>
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">{error?.data?.message || error.error}</Message>
        ) : (
          <Form onSubmit={submitHandler}>
            {highlites.map((highlite, index) => (
              <div
                key={index}
                className="m-3 p-3"
                style={{ border: '1px solid #ccc', borderRadius: '8px' }}
              >
                <h4>Écran à la une n°{index + 1}</h4>

                {/* TypeInfo */}
                <Form.Group className="m-2" controlId={`typeInfo-${index}`}>
                  <Form.Select
                    value={highlite.typeInfo}
                    onChange={(e) => handleChange(index, 'typeInfo', e.target.value)}
                  >
                    <option value="newBook">A - Nouveau livre</option>
                    <option value="news">B - Actualité</option>
                    <option value="oldBook">C - Livre à remonter en une</option>
                    <option value="booksCollection">D - Collection à faire découvrir</option>
                    <option value="author">E - Auteur à présenter</option>
                  </Form.Select>
                </Form.Group>




{highlite.typeInfo === 'news' && (
  <Form.Group className="m-2" controlId={`newsId-${index}`}>

    <Form.Control
      type="text"
      placeholder="Chercher une actu..."
      value={searchNewsTerm}
      onChange={(e) => setSearchNewsTerm(e.target.value)}
    />

    {loadingNews ? (
      <Loader />
    ) : (
      <div
        style={{
          maxHeight: '137px',
          overflowY: 'auto',
          border: '1px solid #ccc',
          padding: '5px',
        }}
      >
        {[...newsList]
          .filter((n) =>
            n.title.toLowerCase().includes(searchNewsTerm.toLowerCase())
          )
          .sort((a, b) => {
            if (a._id === highlite.newsId || a._id === highlite.newsId?._id) return -1;
            if (b._id === highlite.newsId || b._id === highlite.newsId?._id) return 1;
            return 0;
          })
          .map((n) => (
            <div key={n._id} style={{ marginBottom: '5px' }}>
              <label style={{ cursor: 'pointer' }}>
                <input
                  type="radio"
                  name={`newsChoice-${index}`}
                  value={n._id}
                  checked={highlite.newsId === n._id || highlite.newsId?._id === n._id}
                  onChange={() => handleIdChange(index, n._id)}
                  style={{ marginRight: '5px' }}
                />
                {n.title}
              </label>
            </div>
        ))}
      </div>
    )}
  </Form.Group>
)}





{highlite.typeInfo === 'author' && (
  <Form.Group className="m-2" controlId={`authorId-${index}`}>

    <Form.Control
      type="text"
      placeholder="Chercher un auteur..."
      value={searchAuthorTerm}
      onChange={(e) => setSearchAuthorTerm(e.target.value)}
    />

    {loadingAuthors ? (
      <Loader />
    ) : (
      <div
        style={{
          maxHeight: '137px',
          overflowY: 'auto',
          border: '1px solid #ccc',
          padding: '5px',
        }}
      >
        {[...authorsList]
          .filter((author) =>
            author.lastName.toLowerCase().includes(searchAuthorTerm.toLowerCase())
          )
          .sort((a, b) => {
            if (a._id === highlite.authorId || a._id === highlite.authorId?._id) return -1;
            if (b._id === highlite.authorId || b._id === highlite.authorId?._id) return 1;
            return 0;
          })
          .map((author) => (
            <div key={author._id} style={{ marginBottom: '5px' }}>
              <label style={{ cursor: 'pointer' }}>
                <input
                  type="radio"
                  name={`authorChoice-${index}`}
                  value={author._id}
                  checked={highlite.authorId === author._id || highlite.authorId?._id === author._id}
                  onChange={() => handleIdChange(index, author._id)}
                  style={{ marginRight: '5px' }}
                />
                {author.firstName} {author.lastName}
              </label>
            </div>
          ))}
      </div>
    )}
  </Form.Group>
)}

{highlite.typeInfo === 'booksCollection' && (
  <Form.Group className="m-2" controlId={`collectionId-${index}`}>

    <Form.Control
      type="text"
      placeholder="Chercher une collection..."
      value={searchBooksCollectionTerm}
      onChange={(e) => setSearchBooksCollectionTerm(e.target.value)}
    />

    {loadingBooksCollections ? (
      <Loader />
    ) : (
      <div
        style={{
          maxHeight: '137px',
          overflowY: 'auto',
          border: '1px solid #ccc',
          padding: '5px',
        }}
      >
        {[...booksCollectionsList]
          .filter((col) =>
            col.name.toLowerCase().includes(searchBooksCollectionTerm.toLowerCase())
          )
          .sort((a, b) => {
            if (a._id === highlite.infoId || a._id === highlite.infoId?._id) return -1;
            if (b._id === highlite.infoId || b._id === highlite.infoId?._id) return 1;
            return 0;
          })
          .map((col) => (
            <div key={col._id} style={{ marginBottom: '5px' }}>
              <label style={{ cursor: 'pointer' }}>
                <input
                  type="radio"
                  name={`collectionChoice-${index}`}
                  value={col._id}
                  checked={highlite.booksCollectionId === col._id || highlite.booksCollectionId?._id === col._id}
                  onChange={() => handleIdChange(index, col._id)}
                  style={{ marginRight: '5px' }}
                />
                {col.name}
              </label>
            </div>
          ))}
      </div>
    )}
  </Form.Group>
)}





                {/* InfoId uniquement si typeInfo est défini ET différent de newBook */}
                {highlite.typeInfo === 'oldBook' && (
                <Form.Group className="m-2" controlId={`infoId-${index}`}>
                  
                  <Form.Control
                    type="text"
                    placeholder="Chercher un livre..."
                    value={searchBookTerm}
                    onChange={(e) => setSearchBookTerm(e.target.value)}
                  />

                  {/* Liste filtrée des livres */}
                  {loadingBooks ? (
                    <Loader />
                  ) : (
                    <div
                      style={{
                        maxHeight: '137px',
                        overflowY: 'auto',
                        border: '1px solid #ccc',
                        padding: '5px',
                      }}
                    >

                      {[...bookList]
                        .filter((book) =>
                          book.title.toLowerCase().includes(searchBookTerm.toLowerCase())
                        )
                        .sort((a, b) => {
                          if (a._id === highlite.bookId || a._id === highlite.bookId?._id) return -1;
                          if (b._id === highlite.bookId || b._id === highlite.bookId?._id) return 1;
                          return 0;
                        })
                        .map((book) => (

                          <div key={book._id} style={{ marginBottom: '5px' }}>
                            <label style={{ cursor: 'pointer' }}>
                              <input
                                type="radio"
                                name={`oldBookChoice-${index}`}
                                value={book._id}
                                checked={highlite.bookId === book._id || highlite.bookId?._id === book._id}
                                onChange={() => handleIdChange(index, book._id)}
                                style={{ marginRight: '5px' }}
                              />
                              {book.title}
                            </label>
                          </div>
                      ))}
                    </div>
                  )}
                </Form.Group>
              )}
              </div>
            ))}

            <Button type="submit" variant="primary" disabled={loadingUpdate}>
              {loadingUpdate ? 'Enregistrement...' : 'Enregistrer'}
            </Button>
          </Form>
        )}
      </FormContainer>
    </Container>
  );
};

export default AdminHome;
